import { useState } from "react";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../hooks/reduxHooks";
import { goToSidebarTab } from "../../../../store/slices/sidebarSlice";
import Popup from "../../Popup";
import DuplicateProject from "../../DuplicateProject";
import RenameProject from "../../RenameProject";
import DownloadPDF from "../../DownloadPDF";
import Preview from "../../Preview";
import SaveDesign from "../../SaveDesign";
import ShareDesign from "../../ShareDesign";
import ShareAndSave from "../../../../../components/Header_new/ShareAndSave";
import { useLocation } from "react-router-dom";

const MobileMenu = () => {
  const dispatch = useAppDispatch();
  const designName = useAppSelector((state: any) => state.canvases.designName);
  const location = useLocation(); // Get the current URL
  const productName = useAppSelector(
    (state: any) => state.canvases.productName
  );

  const isLoggedIn = false;

  const [showMenu, setShowMenu] = useState(false);
  const [showDuplicatePopup, setShowDuplicatePopup] = useState(false);
  const [showRenamePopup, setShowRenamePopup] = useState(false);
  const [showPDFPopup, setShowPDFPopup] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [showSaveDesign, setShowSaveDesign] = useState(false);
  const [showSharePopup, setShowSharePopup] = useState(false);

  const handleAccount = () => {
    dispatch(goToSidebarTab({ tab: "Account" }));
    setShowMenu(false);
  };

  return (
    <>
      <button
        onClick={() => setShowMenu((prev) => !prev)}
        className="lg:hidden text-center px-5 border-r border-solid border-lightgrey text-[10px] cursor-pointer"
      >
        <svg
          className="my-1 mx-auto"
          width="26"
          height="15"
          viewBox="0 0 26 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 1.5C0 0.671573 0.671573 0 1.5 0H24.5C25.3284 0 26 0.671573 26 1.5C26 2.32843 25.3284 3 24.5 3H1.5C0.671572 3 0 2.32843 0 1.5Z"
            fill="#4A4A4A"
          />
          <path
            d="M0 7.5C0 6.67157 0.671573 6 1.5 6H24.5C25.3284 6 26 6.67157 26 7.5C26 8.32843 25.3284 9 24.5 9H1.5C0.671572 9 0 8.32843 0 7.5Z"
            fill="#4A4A4A"
          />
          <path
            d="M0 13.5C0 12.6716 0.671573 12 1.5 12H24.5C25.3284 12 26 12.6716 26 13.5C26 14.3284 25.3284 15 24.5 15H1.5C0.671572 15 0 14.3284 0 13.5Z"
            fill="#4A4A4A"
          />
        </svg>
        Menu
      </button>
      {showMenu && (
        <div className="fixed z-40 bottom-0 w-full">
          <button
            className="absolute top-4 right-4"
            onClick={() => setShowMenu(false)}
          >
            <svg
              width="12"
              height="13"
              viewBox="0 0 12 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.3955 11.1593C11.3955 11.6331 11.228 12.0375 10.8929 12.3726C10.5578 12.7077 10.1591 12.8752 9.69695 12.8752C9.16543 12.8752 8.74367 12.6903 8.4317 12.3206L5.84919 9.23546L3.26669 12.3206C2.95471 12.6903 2.53296 12.8752 2.00144 12.8752C1.53924 12.8752 1.1406 12.7077 0.805513 12.3726C0.470423 12.0375 0.302878 11.6331 0.302878 11.1593C0.302878 10.7318 0.441536 10.3621 0.718852 10.0501L3.63067 6.79161L0.926838 3.81047C0.649523 3.49849 0.510865 3.11718 0.510865 2.66654C0.510865 2.19279 0.67841 1.79415 1.0135 1.47062C1.36014 1.13553 1.76456 0.967983 2.22676 0.967983C2.76983 0.967983 3.21469 1.18752 3.56134 1.62661L5.84919 4.43443L8.13705 1.62661C8.48369 1.18752 8.92855 0.967983 9.47163 0.967983C9.93382 0.967983 10.3325 1.13553 10.6676 1.47062C11.0142 1.79415 11.1875 2.19279 11.1875 2.66654C11.1875 3.12873 11.1009 3.44649 10.9275 3.61981L8.06772 6.79161L10.9795 10.0501C11.2568 10.3621 11.3955 10.7318 11.3955 11.1593Z"
                fill="#CCCFD6"
              />
            </svg>
          </button>
          <div className="bg-white w-full min-h-[75vh] rounded-lg shadow-header">
            <div className="bg-darknavy rounded-t-lg text-white font-bold text-center text-xl tracking-widest py-2">
              Menu
            </div>
            <div className="px-5 py-3 max-lg:overflow-y-auto max-lg:[height:calc(60vh-43px)]">
              <div className="font-bold">
                {designName || "My Unique Design Name"}{" "}
                <button
                  className="mx-1 inline relative top-[4px]"
                  onClick={() => setShowRenamePopup(true)}
                >
                  <svg
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="black"
                    width="18"
                    height="18"
                  >
                    <path d="M834.3 705.7c0 82.2-66.8 149-149 149H325.9c-82.2 0-149-66.8-149-149V346.4c0-82.2 66.8-149 149-149h129.8v-42.7H325.9c-105.7 0-191.7 86-191.7 191.7v359.3c0 105.7 86 191.7 191.7 191.7h359.3c105.7 0 191.7-86 191.7-191.7V575.9h-42.7v129.8z" />
                    <path d="M889.7 163.4c-22.9-22.9-53-34.4-83.1-34.4s-60.1 11.5-83.1 34.4L312 574.9c-16.9 16.9-27.9 38.8-31.2 62.5l-19 132.8c-1.6 11.4 7.3 21.3 18.4 21.3 0.9 0 1.8-0.1 2.7-0.2l132.8-19c23.7-3.4 45.6-14.3 62.5-31.2l411.5-411.5c45.9-45.9 45.9-120.3 0-166.2zM362 585.3L710.3 237 816 342.8 467.8 691.1 362 585.3zM409.7 730l-101.1 14.4L323 643.3c1.4-9.5 4.8-18.7 9.9-26.7L436.3 720c-8 5.2-17.1 8.7-26.6 10z m449.8-430.7l-13.3 13.3-105.7-105.8 13.3-13.3c14.1-14.1 32.9-21.9 52.9-21.9s38.8 7.8 52.9 21.9c29.1 29.2 29.1 76.7-0.1 105.8z" />
                  </svg>
                </button>
              </div>
              <div className="text-sm text-[#5C5C5C] mb-5 mt-4">
                {productName || "Fruit of the Loom® T-shirt"} - Current Product
              </div>
              <ul className="font-bold">
                {/* <li className="my-3" onClick={() => setShowSaveDesign(true)}>
                  <svg
                    className="inline mr-2"
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_44004_32682)">
                      <path
                        d="M5.19006 2.87891V5.82326H10.8077V2.87891M13.7962 4.80908L11.7709 3.02831C11.6613 2.93202 11.5205 2.87891 11.3747 2.87891H2.6C2.26863 2.87891 2 3.14754 2 3.47891V14.2789C2 14.6103 2.26863 14.8789 2.6 14.8789H13.4C13.7314 14.8789 14 14.6103 14 14.2789V5.25967C14 5.08716 13.9257 4.92299 13.7962 4.80908Z"
                        stroke="black"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M8.0024 11.747C9.01769 11.747 9.84074 10.9239 9.84074 9.90865C9.84074 8.89337 9.01769 8.07031 8.0024 8.07031C6.98712 8.07031 6.16406 8.89337 6.16406 9.90865C6.16406 10.9239 6.98712 11.747 8.0024 11.747Z"
                        stroke="black"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_44004_32682">
                        <rect width="16" height="17" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  Save Design
                </li> */}
                {/*  <li
                  className="my-3"
                  onClick={() => setShowDuplicatePopup(true)}
                >
                  <svg
                    className="inline mr-2"
                    width="16"
                    height="18"
                    viewBox="0 0 16 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_44004_32689)">
                      <path
                        d="M10 3.38672H4C3.72386 3.38672 3.5 3.61058 3.5 3.88672V11.8867C3.5 12.1629 3.72386 12.3867 4 12.3867H10C10.2761 12.3867 10.5 12.1629 10.5 11.8867V3.88672C10.5 3.61058 10.2761 3.38672 10 3.38672Z"
                        stroke="black"
                      />
                      <path
                        d="M12 5.38672H6C5.72386 5.38672 5.5 5.61058 5.5 5.88672V13.8867C5.5 14.1629 5.72386 14.3867 6 14.3867H12C12.2761 14.3867 12.5 14.1629 12.5 13.8867V5.88672C12.5 5.61058 12.2761 5.38672 12 5.38672Z"
                        stroke="black"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_44004_32689">
                        <rect
                          width="16"
                          height="17"
                          fill="white"
                          transform="translate(0 0.0078125)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  Duplicate Design
                </li>*/}
                <li className="my-3" onClick={handleAccount}>
                  <svg
                    className="inline mr-2"
                    width="16"
                    height="12"
                    viewBox="0 0 16 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_44004_32695)">
                      <path
                        d="M13.25 3.69762H13.543C13.7055 3.69745 13.8656 3.73687 14.0094 3.81247C14.1532 3.88807 14.2764 3.99758 14.3684 4.13151C14.4604 4.26544 14.5183 4.41976 14.5373 4.58113C14.5562 4.7425 14.5355 4.90605 14.477 5.05762L12.622 9.87463C12.5494 10.0634 12.4213 10.2257 12.2545 10.3401C12.0878 10.4546 11.8903 10.5158 11.688 10.5156H2.45701C2.29454 10.5158 2.13447 10.4764 1.99066 10.4008C1.84684 10.3252 1.72362 10.2157 1.63164 10.0817C1.53966 9.94781 1.4817 9.79349 1.46277 9.63212C1.44385 9.47075 1.46452 9.3072 1.52301 9.15563L3.37801 4.33862C3.45062 4.14987 3.57875 3.98756 3.7455 3.87312C3.91224 3.75868 4.10977 3.69749 4.31201 3.69762H13.25ZM13.25 3.69762V2.42462C13.25 2.15941 13.1447 1.90505 12.9571 1.71752C12.7696 1.52998 12.5152 1.42463 12.25 1.42463H5.80001C5.66559 1.42463 5.53256 1.39753 5.40885 1.34496C5.28514 1.29238 5.1733 1.2154 5.08001 1.11863L4.79501 0.822625C4.70181 0.725666 4.59001 0.648504 4.4663 0.595754C4.34258 0.543004 4.2095 0.515751 4.07501 0.515625H2.43701C2.1718 0.515625 1.91744 0.620982 1.7299 0.808518C1.54237 0.996055 1.43701 1.25041 1.43701 1.51562V9.60563"
                        stroke="black"
                        strokeOpacity="0.9"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_44004_32695">
                        <rect
                          width="16"
                          height="11"
                          fill="white"
                          transform="translate(0 0.015625)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  My Projects
                </li>
                <li className="my-3" onClick={() => setShowPreview(true)}>
                  <svg
                    className="inline mr-2"
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_44004_32700)">
                      <path
                        d="M7.99993 12.8087C5.79651 12.8087 3.29499 10.6724 1.96002 9.35284C1.39275 8.79212 1.41219 7.89864 2.00479 7.36475C3.35033 6.15249 5.8209 4.2373 7.99993 4.2373C10.1789 4.2373 12.6495 6.15249 13.995 7.36475C14.5876 7.89865 14.6071 8.79212 14.0398 9.35284C12.7048 10.6724 10.2033 12.8087 7.99993 12.8087Z"
                        stroke="black"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M10.3002 8.52316C10.3002 9.83455 9.26098 10.8803 8.0002 10.8803C6.73942 10.8803 5.7002 9.83455 5.7002 8.52316C5.7002 7.21178 6.73942 6.16602 8.0002 6.16602C9.26098 6.16602 10.3002 7.21178 10.3002 8.52316Z"
                        stroke="black"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_44004_32700">
                        <rect
                          width="16"
                          height="16"
                          fill="white"
                          transform="translate(0 0.523438)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  Preview
                </li>
                <li className="my-3" onClick={() => setShowSharePopup(true)}>
                  <svg
                    className="inline mr-2"
                    width="14"
                    height="15"
                    viewBox="0 0 14 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M11.1396 5.46638C12.738 5.46638 14 4.24256 14 2.77398C14 1.22382 12.738 0 11.2237 0C9.62523 0 8.36328 1.22382 8.36328 2.6924C8.36328 3.01875 8.44741 3.3451 8.53154 3.67145L4.66155 5.54797C3.48372 4.48733 1.71699 4.56891 0.707428 5.71114C-0.302135 6.85337 -0.218005 8.56671 0.875688 9.54577C1.96938 10.5248 3.56785 10.5248 4.66155 9.54577L8.53154 11.4223C8.02676 12.8093 8.78393 14.3594 10.2983 14.849C11.8126 15.3385 13.327 14.6042 13.8317 13.1356C14.3365 11.667 13.5793 10.1985 12.065 9.70894C11.0554 9.38259 10.0459 9.62735 9.28871 10.2801L5.41872 8.40354C5.58698 7.83242 5.58698 7.26131 5.41872 6.69019L9.28871 4.81368C9.79349 5.22162 10.4665 5.46638 11.1396 5.46638ZM11.1396 1.38699C11.8967 1.38699 12.5698 1.95811 12.5698 2.77398C12.5698 3.58986 11.9809 4.16097 11.1396 4.16097C10.3824 4.16097 9.70936 3.58986 9.70936 2.77398C9.70936 1.95811 10.3824 1.38699 11.1396 1.38699ZM2.81068 8.89306C1.96938 8.89306 1.38047 8.32195 1.38047 7.50607C1.38047 6.69019 1.96938 6.20067 2.81068 6.20067C3.65198 6.20067 4.2409 6.77178 4.2409 7.58766C4.2409 8.40354 3.56785 8.89306 2.81068 8.89306ZM11.1396 10.9328C11.8967 10.9328 12.5698 11.5039 12.5698 12.3197C12.5698 13.1356 11.9809 13.7067 11.1396 13.7067C10.3824 13.7067 9.70936 13.1356 9.70936 12.3197C9.70936 11.5039 10.3824 10.9328 11.1396 10.9328Z" />
                  </svg>
                  Share Design
                </li>

                {location.pathname === "/designer/design" && (
                  <li className="my-3" onClick={() => setShowPDFPopup(true)}>
                    <svg
                      className="inline mr-2"
                      width="16"
                      height="18"
                      viewBox="0 0 16 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_44004_32713)">
                        <path
                          d="M2.24731 14.8594H14.2473"
                          stroke="black"
                          strokeLinecap="round"
                        />
                        <path
                          d="M8.30688 10.5751L8.3082 2.77026"
                          stroke="black"
                          strokeLinecap="round"
                        />
                        <path
                          d="M5.58057 8.54492L8.30713 11.5273L11.0337 8.54492"
                          stroke="black"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_44004_32713">
                          <rect
                            width="16"
                            height="17"
                            fill="white"
                            transform="translate(0 0.0390625)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                    Download The PDF
                  </li>
                )}
                <li className="my-3" onClick={handleAccount}>
                  <svg
                    className="inline mr-2"
                    width="15"
                    height="14"
                    viewBox="0 0 15 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.5 0.137695C3.36 0.137695 0 3.14868 0 6.85865C0 10.5686 3.36 13.5796 7.5 13.5796C11.64 13.5796 15 10.5686 15 6.85865C15 3.14868 11.64 0.137695 7.5 0.137695ZM7.5 2.15398C8.745 2.15398 9.75 3.05459 9.75 4.17027C9.75 5.28595 8.745 6.18656 7.5 6.18656C6.255 6.18656 5.25 5.28595 5.25 4.17027C5.25 3.05459 6.255 2.15398 7.5 2.15398ZM7.5 11.6977C5.625 11.6977 3.9675 10.8375 3 9.53359C3.0225 8.19612 6 7.46354 7.5 7.46354C8.9925 7.46354 11.9775 8.19612 12 9.53359C11.0325 10.8375 9.375 11.6977 7.5 11.6977Z"
                      fill="black"
                    />
                  </svg>
                  My Account
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}

      {showSharePopup && (
        <ShareAndSave setSaveSharePopup={setShowSharePopup}></ShareAndSave>
      )}
      <Popup
        show={showDuplicatePopup}
        setShow={setShowDuplicatePopup}
        title="Duplicate Project"
      >
        <DuplicateProject oldName={"My First Project"} />
      </Popup>

      <Popup
        show={showRenamePopup}
        setShow={setShowRenamePopup}
        title="Rename Design"
      >
        <RenameProject
          oldName={"My First Project"}
          showRenamePopup={setShowRenamePopup}
        />
      </Popup>

      <Popup
        show={showPDFPopup}
        setShow={setShowPDFPopup}
        title="Download The PDF
"
      >
        <DownloadPDF />
      </Popup>

      <Preview
        show={showPreview}
        setShow={setShowPreview}
        title="Preview"
      ></Preview>

      <Popup
        show={showSaveDesign}
        setShow={setShowSaveDesign}
        title="Save Design"
      >
        <SaveDesign isLoggedIn={isLoggedIn} closePopup />
      </Popup>

      {/* <Popup
        show={showSharePopup}
        setShow={setShowSharePopup}
        title="Share Your Design"
      >
        <ShareDesign show={showSharePopup} />
      </Popup> */}
    </>
  );
};
export default MobileMenu;
